import React from 'react'
import * as SVGIcons from '@components/Svg/SVGIcons.js'

/**
 * Get Icon
 * @param {*} icon
 */

export const getIcon = icon => {
    if (SVGIcons[icon]) {
        return SVGIcons[icon]
    } else {
        return NoIcon
    }
}

const NoIcon = () => {
    return <span></span>
}
